import { Trans, useTranslation } from "react-i18next";
import { Box, Stack, theme } from "@mzc-pdc/ui";
import Typography from "@components_v2/typography/typography";
import { useSelector } from "react-redux";
import { PROPERTY_PANEL_TYPE } from "@constants";
import React from "react";

const PanelExpiredError = () => {
    const { t } = useTranslation();

    const { propertyPanel } = useSelector(({ propertyPanel }) => ({
        propertyPanel,
    }));

    return (
        <Box className={"box-permission"} textAlign="center">
            <Box>
                <i className="sprite sprite-error-permission" />
            </Box>
            <Stack direction={"column"} gap={theme.spacing(2)} my={theme.spacing(2)}>
                <Typography sx={{ fontSize: "15px", fontWeight: 700 }}>
                    {t(`common::msg::Access has Expired`, `Access has Expired`)}
                </Typography>
                <Typography variant={"body1_300"}>
                    {propertyPanel.type === PROPERTY_PANEL_TYPE.SHARED_STORAGE_WITH ? (
                        <Trans
                            i18nKey="common::msg::The sharing period for this file has expired. <0/> If you want to check the file you have selected, <0/> Please ask the sharer to share."
                            components={[<br />]}
                        />
                    ) : (
                        <Trans
                            i18nKey="common::msg::If you want to check the assets you have selected, <0/> please ask for access."
                            components={[<br />]}
                        />
                    )}
                </Typography>
            </Stack>
        </Box>
    );
};

export default PanelExpiredError;
